module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    class: _vm.$style['list']
  }, [(_vm.state === 'ACTIVATE' || _vm.state === 'HAS_PORTAL') ? _c('li', [_c('router-link', {
    attrs: {
      "to": _vm.toUrl
    }
  }, [_vm._v("Activate portal")])], 1) : _c('li', [_c('div', [_vm._v("Unable to activate.")]), _vm._v(" "), (_vm.contactCount === 0) ? _c('div', [_vm._v("Customer has no Contacts.")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-0a27eb8e"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IsrsActiveOrOpenPortalBtn.vue
// module id = 917
// module chunks = 1